// plugins/file-upload.ts

export interface FileUploadOptions {
  fileInputId?: string;
  fileListId?: string;
}

const defaults: FileUploadOptions = {
  fileInputId: "fileUpload",
  fileListId: "fileUploadList",
};

export class FileUploadManager {
  private options: FileUploadOptions;
  private dt = new DataTransfer();
  private fileInput: HTMLInputElement | null = null;
  private fileList: HTMLUListElement | null = null;

  constructor(opts: FileUploadOptions = {}) {
    this.options = { ...defaults, ...opts };
    this.fileInput = document.getElementById(
      this.options.fileInputId!,
    ) as HTMLInputElement;
    this.fileList = document.getElementById(
      this.options.fileListId!,
    ) as HTMLUListElement;
    if (!this.fileInput || !this.fileList) return; // required elements not found, do not initialize
    this.setup();
  }

  private setup(): void {
    this.fileInput?.addEventListener("change", () => {
      Array.from(this.fileInput?.files ?? []).forEach((file) => {
        this.dt.items.add(file);
      });
      this.fileInput!.files = this.dt.files;
      this.renderList();
    });
  }

  private renderList(): void {
    this.fileList!.innerHTML = "";
    Array.from(this.dt.files).forEach((file, index) => {
      const li = document.createElement("li");
      const span = document.createElement("span");
      span.textContent = file.name;
      const btn = document.createElement("button");
      btn.type = "button";
      btn.dataset["index"] = String(index);
      btn.innerHTML = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M13.2621 12.2672L1.73267 0.737558C1.40677 0.411657 0.887204 0.40284 0.572183 0.717866L0.570428 0.719621C0.255408 1.03465 0.264225 1.55422 0.590121 1.88012L12.1195 13.4097C12.4454 13.7356 12.965 13.7444 13.28 13.4294L13.2817 13.4277C13.5968 13.1126 13.588 12.5931 13.2621 12.2672Z" fill="#0360A3"/><path d="M1.88052 13.2623L13.4099 1.73268C13.7358 1.40677 13.7446 0.887199 13.4296 0.572173L13.4279 0.570418C13.1128 0.255392 12.5933 0.264209 12.2674 0.590111L0.737978 12.1197C0.412082 12.4456 0.403265 12.9652 0.718285 13.2802L0.72004 13.282C1.03506 13.597 1.55463 13.5882 1.88052 13.2623Z" fill="#0360A3"/></svg>`;
      btn.addEventListener("click", () => {
        this.dt.items.remove(index);
        this.fileInput!.files = this.dt.files;
        this.renderList();
      });
      li.appendChild(span);
      li.appendChild(btn);
      this.fileList!.appendChild(li);
    });
  }
}
